import { api } from "./api";

// Build the prefilled WhatsApp message and open wa.me
export function buildWhatsappMessage({ customerName, product, category, referralCode, discount, bonusType, template }) {
  const bonusText = [bonusType, discount].filter(Boolean).join(" ");
  if (template && template.trim()) {
    let msg = template
      .replaceAll("[NOME CLIENTE]", customerName || "")
      .replaceAll("[NOME PRODOTTO]", product || "")
      .replaceAll("[CATEGORIA]", category || "")
      .replaceAll("[CODICE]", referralCode || "");
    if (referralCode) {
      msg += ` Codice promozionale: ${referralCode}.`;
      if (bonusText) msg += ` Bonus previsto: ${bonusText}.`;
    }
    return msg;
  }

  let msg = customerName ? `Ciao, sono ${customerName}. Sono interessato a ${product || "un servizio"}` : `Ciao, sono interessato a ${product || "un servizio"}`;
  if (category) msg += ` nella categoria ${category}`;
  msg += ".";
  if (referralCode) {
    msg += ` Il mio codice promozionale è ${referralCode}`;
    if (bonusText) msg += ` (bonus: ${bonusText})`;
    msg += ".";
  }
  msg += " Vorrei ricevere maggiori informazioni.";
  return msg;
}

export function sanitizeNumber(number) {
  return (number || "").replace(/[^0-9]/g, "");
}

// Track the lead then open WhatsApp
export async function openWhatsapp({ number, customerName, product, category, referralCode, discount, bonusType, template }) {
  const cleanNumber = sanitizeNumber(number);
  const message = buildWhatsappMessage({ customerName, product, category, referralCode, discount, bonusType, template });

  // Fire-and-forget lead tracking
  try {
    await api.post("/leads", {
      customer_name: customerName || "",
      referral_code: referralCode || "",
      selected_product: product || "",
      selected_category: category || "",
      bonus_type: bonusType || "",
      bonus_value: discount || "",
      whatsapp_clicked: true,
      user_agent: navigator.userAgent,
      landing_url: window.location.href,
    });
  } catch (e) {
    // tracking failure should not block the user
  }

  if (!cleanNumber) {
    return { ok: false, reason: "no_number", message };
  }

  const url = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank", "noopener,noreferrer");
  return { ok: true, url };
}
